/***************************************************************************************************
 * CUSTOM POLYFILLS: define globals early
 **************************************************************************************************/
(window as any).process = {
  env: {
    NODE_ENV: 'production',
    NODE_DEBUG: 'true',
    DEBUG: 'true'
  }
};
// (window as any).URL = require('url').URL;
(window as any).URL = window.URL;
(window as any).assert = require('assert');
(window as any).util = require('util');

/***************************************************************************************************
 * Zone JS is required by Angular itself.
 */
import 'zone.js';  // Already in polyfills
